
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import "../common/Focusable/Focusable.st.css.js";
import "../Image/Image.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_ImageViewer";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_ImageViewer__root","buttons":"wds_1_220_3_ImageViewer__buttons","imageContainer":"wds_1_220_3_ImageViewer__imageContainer","overlay":"wds_1_220_3_ImageViewer__overlay","image":"wds_1_220_3_ImageViewer__image","statusContainer":"wds_1_220_3_ImageViewer__statusContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-image-border-radius-default":"--wds-image-border-radius-default","wds-color-fill-transparent-primary":"--wds-color-fill-transparent-primary","wds-color-black-100-transparent-5":"--wds-color-black-100-transparent-5","wds-color-border-warning-secondary-active":"--wds-color-border-warning-secondary-active","wds-color-blue-600":"--wds-color-blue-600","wds-color-border-destructive-secondary-active":"--wds-color-border-destructive-secondary-active","wds-color-fill-light-secondary":"--wds-color-fill-light-secondary"}; 




